const SampleOccupancyData: { date: string, value: number }[] = [
  {
    date: '2024-06-29T00:00:00.000Z',
    value: 6,
  },
  {
    date: '2024-06-30T00:00:00.000Z',
    value: 6,
  },
  {
    date: '2024-07-01T00:00:00.000Z',
    value: 25,
  },
  {
    date: '2024-07-02T00:00:00.000Z',
    value: 28,
  },
  {
    date: '2024-07-03T00:00:00.000Z',
    value: 32,
  },
  {
    date: '2024-07-04T00:00:00.000Z',
    value: 24,
  },
  {
    date: '2024-07-05T00:00:00.000Z',
    value: 11,
  },
  {
    date: '2024-07-06T00:00:00.000Z',
    value: 1,
  },
  {
    date: '2024-07-07T00:00:00.000Z',
    value: 1,
  },
  {
    date: '2024-07-08T00:00:00.000Z',
    value: 19,
  },
  {
    date: '2024-07-09T00:00:00.000Z',
    value: 34,
  },
  {
    date: '2024-07-10T00:00:00.000Z',
    value: 26,
  },
  {
    date: '2024-07-11T00:00:00.000Z',
    value: 21,
  },
  {
    date: '2024-07-12T00:00:00.000Z',
    value: 24,
  },
  {
    date: '2024-07-13T00:00:00.000Z',
    value: 12,
  },
  {
    date: '2024-07-14T00:00:00.000Z',
    value: 0,
  },
  {
    date: '2024-07-15T00:00:00.000Z',
    value: 27,
  },
  {
    date: '2024-07-16T00:00:00.000Z',
    value: 35,
  },
  {
    date: '2024-07-17T00:00:00.000Z',
    value: 18,
  },
  {
    date: '2024-07-18T00:00:00.000Z',
    value: 24,
  },
  {
    date: '2024-07-19T00:00:00.000Z',
    value: 25,
  },
  {
    date: '2024-07-20T00:00:00.000Z',
    value: 0,
  },
  {
    date: '2024-07-21T00:00:00.000Z',
    value: 0,
  },
  {
    date: '2024-07-22T00:00:00.000Z',
    value: 18,
  },
  {
    date: '2024-07-23T00:00:00.000Z',
    value: 19,
  },
  {
    date: '2024-07-24T00:00:00.000Z',
    value: 15,
  },
  {
    date: '2024-07-25T00:00:00.000Z',
    value: 23,
  },
  {
    date: '2024-07-26T00:00:00.000Z',
    value: 14,
  },
  {
    date: '2024-07-27T00:00:00.000Z',
    value: 13,
  },
  {
    date: '2024-07-28T00:00:00.000Z',
    value: 13,
  },
  {
    date: '2024-07-29T00:00:00.000Z',
    value: 20,
  },
];

// eslint-disable-next-line import/prefer-default-export
export { SampleOccupancyData };
